import { RotatingCache } from "../../../hooks";
import { API } from "../../types";

type By = "official" | "collections" | "search" | "topics";

export type ImageSource = "unsplash" | "pexels" | "pixabay" | "nasa" | "mixed";

export interface Data {
  source: ImageSource;
  by: By;
  collections: string;
  featured: boolean;
  paused?: boolean;
  search: string;
  topics: string;
  timeout: number;
}

export interface Image {
  src: string;
  source: string;
  sourceLink: string;
  credit: {
    imageLink: string;
    location?: string;
    userName: string;
    userLink: string;
  };
}

type Cache = RotatingCache<Image>;

export type Props = API<Data, Cache>;

export const defaultData: Data = {
  source: "mixed",
  by: "official",
  collections: "",
  featured: false,
  paused: false,
  search: "",
  topics: "bo8jQKTaE0Y",
  timeout: 900,
};

// White-list search terms for natural imagery (landscape, nature, sky, stars, flowers, plants, animals, space)
export const NATURE_SEARCH_DEFAULTS: Record<ImageSource, string> = {
  unsplash: "nature landscape",
  pexels: "nature landscape sky",
  pixabay: "nature landscape flowers",
  nasa: "galaxy nebula stars",
  mixed: "",
};
